<template>
  <div class="dialog" :class="{'dialogBG':dialogConfig.types!='fail'&&dialogConfig.types!='succ'?true:false}" v-if="dialogConfig.status">
    <div class="fail" v-if="dialogConfig.types=='fail'||dialogConfig.types=='succ'">
      <div class="dialog-content" :class="{'failColor':dialogConfig.types=='fail'}">{{dialogConfig.mess}}</div>
    </div>
    <div class="dialog-wrapper" v-else>
      <div class="dialog-content">{{dialogConfig.mess}}</div>
      <div class="border_bottom"></div>
      <div class="dialog-btns" v-if="dialogConfig.buttons.length>1">
        <div v-for="button in dialogConfig.buttons" @click="button.affair">{{$t(button.name)}}</div>
      </div>
      <div class="dialog-btn" v-else>
        <div v-for="button in dialogConfig.buttons" @click="button.affair">{{$t(button.name)}}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .fail .dialog-content {
    background: rgba(0, 0, 0, .7);
    color: #fff;
    border-radius: 0.1rem;
    border-radius: 0.04rem;
    max-width: 3rem;
  }

  .dialog .fail .failColor {
    background: #fef0f0;
    color: #f56c6c;
  }

  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index:101;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialogBG {
    background: rgba(0, 0, 0, .4);
  }

  .dialog-wrapper {
    background-color: #fff;
    width: 2.3rem;
    border-radius: 0.05rem
  }

  .dialog-content {
    padding:0.1rem 0.05rem;
    text-align: center;
  }

  .dialog-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dialog-btns>div {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
  }

  .dialog-btns>div:first-child {
    color: #fc4f42;
    font-size: 0.16rem;
  }

  .dialog-btn>div {
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
  }

</style>
<script>
  export default {
    data() {
      return {}
    },
    computed: {
      dialogConfig() {
        return this.$store.getters.dialogConfig
      }
    },
    methods: {

    }
  }

</script>



// WEBPACK FOOTER //
// dialogs.vue?60f9e40a